// extracted by mini-css-extract-plugin
module.exports = {"formInput":"FormInput_formInput__dTGdM","error":"FormInput_error__3eW1K","customError":"FormInput_customError__1eF-9"};